export default __webpack_public_path__ + "static/media/david-anolick.c261337a.png";